import { render, staticRenderFns } from "./ScaleProducts.vue?vue&type=template&id=5964f9ee"
import script from "./ScaleProducts.vue?vue&type=script&lang=js"
export * from "./ScaleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports